import { createApp } from 'vue'
import Age from './Age.vue'
import './assets/global.css'

createApp(Age).mount('#age')
